

const initialState = {
    schedulersDetailsError: {
       jobNameErr: {},
       jobTypeErr: {},
       weekDayErr: {},
       monthDateErr: {},
       triggerTimeErr:{}
    }
  };
  
  const systemSettingErrorReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SCHEDULERSDETAILSERROR':
        if (!action.payload) {
          return initialState;
        } else {
          return {
            ...state,
            schedulersDetailsError: action.payload
          };
        }
      default:
        return state;
    }
  };
  
  export default systemSettingErrorReducer;